import en from '../languages/en.json'
import es from '../languages/es.json'
import pt from '../languages/pt.json'

export default {
    en, es, pt
}